import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
/**
 * Componente para mostrar un mensaje de error cuando los servicios
 * no están disponibles al iniciar la aplicación
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-page-error',
  imports: [AppTranslationPipe],
  template: `
    <div class="page-wrapper">
      <section class="card" role="alert" aria-live="polite">
        <div class="content">
          <div class="status-pill">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ httpErrorCode() }}</span>
          </div>
          <h1 class="title">{{ 'security.service-error' | translate }}</h1>
          <p class="message">
            {{ 'security.service-error-message' | translate }}
          </p>

          <div class="actions">
            <a class="retry-link" role="button" tabindex="0" href="/">
              {{ 'security.service-error-retry' | translate }}
            </a>
          </div>
        </div>
      </section>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex: 1;
      height: 100%;
      overflow: hidden;
      --se-ink: #0f172a;
      --se-muted: #475569;
      --se-primary: #5a8ad7;
      --se-primary-strong: #2d6df6;
      --se-surface-soft: #f5f8ff;
    }

    .page-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 100%;
      overflow: hidden;
      padding: 2.5rem 1.25rem;
    }

    .card {
      position: relative;
      z-index: 1;
      background: transparent;
      border-radius: 1.25rem;
      max-width: 480px;
      width: 100%;
      text-align: center;
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.25rem;
    }

    .status-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      background: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 999px;
      padding: 0.375rem 1rem;
      font-size: 0.875rem;
      font-weight: 600;
      color: #92400e;
    }

    .title {
      font-size: 1.5rem;
      font-weight: 700;
      color: var(--se-ink);
      margin: 0;
    }

    .message {
      font-size: 0.93rem;
      color: var(--se-muted);
      line-height: 1.6;
      margin: 0;
    }

    .actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.75rem;
    }

    .retry-link {
      display: inline-flex;
      align-items: center;
      gap: 0.4rem;
      margin-top: 0.25rem;
      color: var(--se-primary-strong);
      font-size: 0.92rem;
      font-weight: 500;
      text-decoration: underline;
      text-underline-offset: 0.2rem;
      cursor: pointer;
      transition: color 0.2s ease;
    }

    .retry-link i {
      font-size: 0.82rem;
    }

    .retry-link:hover {
      color: var(--ad-primary);
    }

    .retry-link:focus-visible {
      outline: 3px solid rgba(37, 99, 235, 0.25);
      outline-offset: 2px;
      border-radius: 0.35rem;
    }
  `
})
export class PageErrorComponent {
  /** Código de error HTTP (default: 503) */
  httpErrorCode = input(503);
}
